import { API_ENDPOINT } from "@/constants/appConstants";

import { FormattedData, PrefilledDataReturnType, SearchData } from "./types";

export const SHOW_TOP_LOCATION = "rexmonster";
export const brandLogoName = `foundit Logo`;
export const brandLogo = `//media.foundit.in/trex/public/theme_3/src/assets/images/header/companyLogo.svg`;

export const changeArrayToObjFormat = (
  dataArray: string[],
): FormattedData[] => {
  const formattedData: FormattedData[] = [];
  dataArray.forEach((element: string, idx: number) => {
    formattedData.push({ name: element, id: idx });
  });
  return formattedData;
};

export const loginRedirectTo = () => {
  document.location.href =
    "/rio/login/seeker?return_url=" +
    window.location.pathname +
    window.location.search;
};

export const loginRedirectToJobRecommendations = (isLoggedIn: boolean) => {
  document.location.href = isLoggedIn
    ? "/seeker/dashboard?utm_campaign=PrepAI&utm_source=prep-ai&utm_medium=Organic"
    : "/rio/login/seeker?return_url=/seeker/dashboard?utm_campaign=PrepAI&utm_source=login_registration&utm_medium=Organic";
};

export const regiterloginRedirectTo = () => {
  document.location.href = "/seeker/registration";
};

export const employersLoginRedirectTo = () => {
  document.location.href = `https://recruiter.foundit.in`;
};

export const updateUrlString = (str: string) => {
  const urlArr = str.split(", ");
  const newArr = [];

  for (let i = 0; i < urlArr.length; i++) {
    if (urlArr[i]) {
      newArr.push(encodeURIComponent(urlArr[i]));
    }
  }

  return newArr.join(",");
};

export const recentSearchSelectHandler = (item: string) => {
  const baseUrl = "/srp/results?";
  const dynamicUrl = "query=" + updateUrlString(item);
  const queryWithEntities = "";

  window.location.href = baseUrl + dynamicUrl + queryWithEntities;
};

export const fetchDataToBePrefilled = (): PrefilledDataReturnType => {
  const storedData = window.localStorage.getItem("prefilledData");
  const searchData: SearchData = storedData ? JSON.parse(storedData) : {};

  if (searchData.query?.length) {
    const desiredLengthForSearchresult = 3;
    const data: string[] = searchData.query
      ?.slice(0, desiredLengthForSearchresult)
      ?.map((elem) => (typeof elem === "object" ? elem.join(", ") : elem));

    const recentSearches: FormattedData[] = changeArrayToObjFormat(
      data,
    ) as FormattedData[];

    return { recentSearches };
  }

  if (searchData.locations) {
    const prefilledDataforLocation = searchData.locations.join(", ");
    return { prefilledDataforLocation };
  }

  return {};
};

export const handlerLoginRegister = (isLoggedIn: boolean) => {
  return {
    loginBtnClick: isLoggedIn ? null : loginRedirectTo,
    registerBtnClick: isLoggedIn ? null : regiterloginRedirectTo,
    employersLoginBtnClick: isLoggedIn ? null : employersLoginRedirectTo,
  };
};

export const capitalizeFirstLetterofAllWords = (str: string): string => {
  return str
    ?.split(" ")
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    ?.join(" ");
};

export const formatDataToUpdateSearchQueries = (element: string): string => {
  const value: string = element.replaceAll('"', '"').trim();
  return value.length ? capitalizeFirstLetterofAllWords(value) : value;
};

export const saveLastSearchData = ({ query, location = [] }: queryType) => {
  const storedData = window.localStorage.getItem("prefilledData");
  const searchData = storedData !== null ? JSON.parse(storedData) : {};

  const locationData = location.length > 0 ? location.join(", ") : "";
  const queryData = query.join(", ");
  const newLocData =
    locationData.toLowerCase().includes("anywhere") ||
    locationData.toLowerCase().includes("other india");
  const newlocationQueryInBox = newLocData ? "" : locationData;
  const newJobSearchQueryInBox = queryData;
  const desiredLengthForSearchResult = 3;

  const formatAndFilter = (input: string, output: string[]) => {
    input.split(",").forEach((element: string) => {
      const formattedValue = formatDataToUpdateSearchQueries(element);
      if (formattedValue?.length) output.push(formattedValue);
    });
  };

  if (newlocationQueryInBox.length > 0) {
    const newLocationQuery: string[] = [];
    formatAndFilter(newlocationQueryInBox, newLocationQuery);
    searchData.locations = newLocationQuery;
  }

  if (newJobSearchQueryInBox.length > 0) {
    const newSearchQuery: string[] = [];
    let searchQuery = searchData.query || [];
    formatAndFilter(newJobSearchQueryInBox, newSearchQuery);

    searchQuery.length > desiredLengthForSearchResult &&
      (searchQuery.length = desiredLengthForSearchResult);
    searchQuery = [newSearchQuery, ...searchQuery];
    searchData.query = searchQuery;
  }

  localStorage.setItem("prefilledData", JSON.stringify(searchData));
};

export const processSearchedData = ({
  query,
  location,
  exp,
  showNewSEOPage = true,
}: queryType & { showNewSEOPage?: boolean }) => {
  let baseUrl = "/srp/results";
  let dataArr = [`query=${query.join(", ")}`];

  if (showNewSEOPage) {
    baseUrl = `${window.location.origin}/search/${query[0]
      .toLowerCase()
      .replaceAll('"', "")
      .replaceAll(" ", "-")}-jobs`;

    if (location.length > 0) {
      baseUrl += `-in-${location[0]
        .toLowerCase() // Remove any non-alphanumeric characters (except spaces and hyphens)
        .replace(/[^\w\s-]/g, " ")
        // Replace consecutive spaces with a single hyphen
        .replace(/\s+/g, "-")
        // Remove leading and trailing hyphens, if any
        .replace(/^-+|-+$/g, "")}`;
    }

    dataArr = ["query=" + encodeURIComponent(query.toString())];
  }

  if (location.length > 0) {
    dataArr.push(`locations=${location.join(", ")}`);
  }

  if (exp !== "") {
    const expNum = parseInt(exp, 10) || 0;

    dataArr.push(`experienceRanges=${expNum}~${expNum}`);
    dataArr.push(`experience=${expNum}`);
  }

  saveLastSearchData({ query, location, exp });

  const dynamicUrl = `${baseUrl}?${dataArr.join("&")}&queryDerived=true`;
  window.location.href = dynamicUrl;
};

export const callAutoFillAPI = ({
  name,
  value,
  _cb,
}: {
  name: string;
  value: string;
  _cb: ({ value }: { value: string[] }) => void;
}) => {
  let payload = "";

  switch (name) {
    case "SKILLS":
      payload = `query=${value}&size=15&limit=8`;
      break;
    case "LOCATION":
      payload = `query=${value}&size=10&type=locations&siteContext=rexmonster&limit=8`;
      break;
    default:
      break;
  }

  if (payload) {
    (async () => {
      const res = await fetch(`/seeker-profile/api/autoFill?${payload}`, {
        method: "GET",
        headers: {
          baseUrl: JSON.stringify(
            API_ENDPOINT(window.location.host).ravenApi.autoFill,
          ),
        },
      });
      const response = await res.json();
      _cb({ value: response?.data?.length > 0 ? response.data : [] });
    })().catch((err) => {
      _cb({ value: [] });
      console.error(err, "error");
    });
  } else {
    _cb({ value: [] });
  }
};

export const generateExperienceYear = () => {
  const experienceYear = Array.from({ length: 51 }, (_, i) => ({
    id: i,
    name: i === 0 ? "Fresher" : `${i} Year${i > 1 ? "s" : ""}`,
  }));

  return experienceYear;
};
